'use client';

import { analiticaStatusPageEvents } from '@payments-checkout/shared/plugins/analitica/statusPage.events';
import { Button, CardContainer, Divider, Text } from '@stone-payments/jade';
import { useIntl } from 'react-intl';
import { Delivery } from '../../types/sessionStatus.types';

type DeliveryStatusProps = {
  deliveryData?: Delivery;
};

export function DeliveryStatus({ deliveryData }: DeliveryStatusProps) {
  const { formatMessage } = useIntl();

  return (
    <CardContainer className="w-full">
      <div className="flex flex-col">
        <div
          className={`flex flex-col items-center gap-3 p-5 border-b border-jade-border-low ${
            (deliveryData?.errors?.length ?? 0) > 0
              ? 'bg-jade-background-warning-subtle'
              : ''
          }`}
        >
          <div className="flex flex-col items-center gap-1 w-full">
            {(deliveryData?.errors?.length ?? 0) > 0 ? (
              <Text
                variant="text-medium"
                className="text-center"
                color="warning"
                weight="medium"
              >
                {formatMessage({ id: 'statusPage.deliveryError' })}
              </Text>
            ) : (
              <Text variant="heading-small" className="text-center">
                {formatMessage({ id: 'statusPage.deliveryTitle' })}
              </Text>
            )}
          </div>
        </div>
        <Divider direction="horizontal" size="small" />
        {(deliveryData?.errors?.length ?? 0) > 0 ? (
          <>
            <div className="m-jade-200 pt-1 flex items-center justify-center">
              {deliveryData?.errors?.map((error: string, index: number) => (
                <Text
                  variant="text-medium"
                  className="text-center"
                  color="medium"
                  weight="medium"
                >
                  {error}
                </Text>
              ))}
            </div>
          </>
        ) : (
          <>
            <div className="flex flex-col items-center gap-1 p-5">
              <Text
                variant="text-medium"
                className="text-center"
                color="medium"
                weight="medium"
              >
                {formatMessage({ id: 'statusPage.deliverySubtitle' })}
              </Text>
            </div>

            <div className="p-5 pt-1 flex items-center justify-center">
              <Button
                size="small"
                onClick={() => {
                  analiticaStatusPageEvents.events.statusPage.trackPackageClicked();
                  window.open(deliveryData?.tracking_url, '_blank');
                }}
                className="min-w-2"
              >
                {formatMessage({ id: 'statusPage.trackPackage' })}
              </Button>
            </div>
          </>
        )}
      </div>
    </CardContainer>
  );
}
